import './TextInputInnerVisualSlot-ea0eb3f6.css';

var styles = {"Spinner":"prc-components-Spinner-Azb7p","SpinnerLeading":"prc-components-SpinnerLeading-s-LyA","SpinnerHidden":"prc-components-SpinnerHidden-GG1PJ","SpinnerVisible":"prc-components-SpinnerVisible-w5g8l"};

export { styles as default };
